import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, BookOpen, Calendar, Rocket } from 'lucide-react';
export function ProductOverviewSection() {
  return <Section className="bg-navy-800" data-id="element-248">
      <div className="text-center mb-8 md:mb-16" data-id="element-249">
        <p className="text-gold-400 font-bold tracking-widest uppercase text-xs sm:text-sm mb-2 md:mb-4" data-id="element-250">
          Sistema N°1 para Profesores de Gimnasia Artística en Argentina
        </p>
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-white mb-3 md:mb-6" data-id="element-251">
          GIMNASIA ARTÍSTICA RESUELTA™
        </h2>
        <p className="text-base md:text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-252">
          6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
        </p>
      </div>

      <div className="grid grid-cols-3 gap-3 md:gap-8 mb-8 md:mb-16" data-id="element-253">
        <div className="bg-navy-900 p-4 md:p-8 rounded-xl md:rounded-2xl border border-navy-700 text-center flex flex-col items-center" data-id="element-254">
          <BookOpen className="w-8 h-8 md:w-12 md:h-12 text-gold-400 mb-2 md:mb-4" data-id="element-255" />
          <h3 className="text-xl md:text-3xl font-bold text-white mb-1" data-id="element-256">
            +600
          </h3>
          <p className="text-gray-400 uppercase tracking-wide text-[10px] md:text-sm" data-id="element-257">
            Páginas de contenido
          </p>
        </div>
        <div className="bg-navy-900 p-4 md:p-8 rounded-xl md:rounded-2xl border border-navy-700 text-center flex flex-col items-center" data-id="element-258">
          <Calendar className="w-8 h-8 md:w-12 md:h-12 text-magenta-500 mb-2 md:mb-4" data-id="element-259" />
          <h3 className="text-xl md:text-3xl font-bold text-white mb-1" data-id="element-260">60+</h3>
          <p className="text-gray-400 uppercase tracking-wide text-[10px] md:text-sm" data-id="element-261">
            Clases listas para usar
          </p>
        </div>
        <div className="bg-navy-900 p-4 md:p-8 rounded-xl md:rounded-2xl border border-navy-700 text-center flex flex-col items-center" data-id="element-262">
          <Rocket className="w-8 h-8 md:w-12 md:h-12 text-green-400 mb-2 md:mb-4" data-id="element-263" />
          <h3 className="text-xl md:text-3xl font-bold text-white mb-1" data-id="element-264">
            100%
          </h3>
          <p className="text-gray-400 uppercase tracking-wide text-[10px] md:text-sm" data-id="element-265">
            Funciona hoy en tu gimnasio
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-12 max-w-5xl mx-auto" data-id="element-266">
        <div className="bg-navy-900/50 p-4 md:p-8 rounded-xl md:rounded-2xl border border-navy-700" data-id="element-267">
          <h3 className="text-lg md:text-2xl font-bold text-white mb-3 md:mb-6 flex items-center" data-id="element-268">
            <span className="w-6 md:w-8 h-1 bg-gold-500 mr-3 md:mr-4 rounded-full" data-id="element-269"></span>
            Niveles y enfoques incluidos:
          </h3>
          <ul className="space-y-2 md:space-y-4" data-id="element-270">
            {['Iniciación', 'Intermedio', 'Avanzado', 'Exhibición y Competencia', 'Planificación Anual', 'Gestión de Clases'].map((item, i) => <li key={i} className="flex items-center space-x-2 md:space-x-3 text-gray-300 text-sm md:text-lg" data-id="element-271">
                <CheckCircle2 className="w-4 h-4 md:w-6 md:h-6 text-green-400 flex-shrink-0" data-id="element-272" />
                <span data-id="element-273">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-navy-900/50 p-4 md:p-8 rounded-xl md:rounded-2xl border border-navy-700" data-id="element-274">
          <h3 className="text-lg md:text-2xl font-bold text-white mb-3 md:mb-6 flex items-center" data-id="element-275">
            <span className="w-6 md:w-8 h-1 bg-magenta-500 mr-3 md:mr-4 rounded-full" data-id="element-276"></span>
            Todo lo que vas a dominar:
          </h3>
          <div className="flex flex-wrap gap-1.5 md:gap-3" data-id="element-277">
            {['Suelo', 'Barra de Equilibrio', 'Salto y Potro', 'Barras Asimétricas', 'Acrobacias', 'Elementos Libres', 'Coreografía', 'Planificación', 'Evaluación', 'Progresión', 'Seguimiento', 'Spotting', 'Seguridad', 'Gestión', 'Competencia'].map((skill, i) => <span key={i} className="bg-navy-800 border border-navy-600 text-gray-300 px-2.5 py-1 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-medium" data-id="element-278">
                {skill}
              </span>)}
          </div>
        </div>
      </div>
    </Section>;
}